import { Alert } from '@mui/material';
import React from 'react';

interface CommonAlertProps {
  severity?: 'error' | 'warning' | 'info' | 'success' | null;
  message?: React.ReactNode;
  sx?: object;
}

const CommonAlert: React.FC<CommonAlertProps> = ({
  severity = null,
  message = '',
  sx = {}
}) => {
  return (
    <Alert severity={severity} sx={sx || {}}>
      {message}
    </Alert>
  );
};

export default CommonAlert;
